export type SchedulePeriodType = 'DAILY' | 'WEEKLY' | 'MONTHLY' | 'YEARLY';

export const SchedulePeriodTypeMap: { [key in SchedulePeriodType]: string } = {
  DAILY: 'day',
  WEEKLY: 'week',
  MONTHLY: 'month',
  YEARLY: 'year',
};
